import { DistanceMetrics } from 'src/types'
import { KM_TO_MILES, MILES_TO_KM } from 'src/constants'

export function convertDistance(
  value: number,
  from: string,
  to: DistanceMetrics,
): number {
  if (from === to) return value

  const raw =
    from === DistanceMetrics.KM ? value * KM_TO_MILES : value * MILES_TO_KM

  const rounded = Number(raw.toFixed(2))

  return Number.isInteger(rounded) ? rounded : rounded
}
